import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { RecipeDto, ReplaceRecipeRequest } from './types';

const QK = (itemId: string) => ['recipe', itemId] as const;

export function useRecipe(itemId: string | null | undefined) {
  return useQuery({
    queryKey: QK(itemId ?? 'none'),
    enabled: !!itemId,
    queryFn: async () =>
      (await apiClient.get<RecipeDto>(`/api/items/${itemId}/recipe`)).data,
  });
}

export function useReplaceRecipe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      itemId,
      request,
    }: {
      itemId: string;
      request: ReplaceRecipeRequest;
    }) =>
      (await apiClient.put<RecipeDto>(`/api/items/${itemId}/recipe`, request))
        .data,
    onSuccess: (dto) => qc.invalidateQueries({ queryKey: QK(dto.itemId) }),
  });
}
